module.exports = __webpack_public_path__ + "static/media/PROGRAMA DE GESTION DOCUMENTAL.fc54ab2b.pdf";